import React from 'react'
import PropTypes from 'prop-types'
import { withSearch } from '@elastic/react-search-ui'
import getSearchImageObj from '../getSearchImgObj'
import { SEARCH_RESULT } from '../../../utils/types'
import { Image, StyledText } from '../..'
import { categoryListStyles } from '../styles'
import resultStyles from './styles'

export const STVResultView = ({
  result,
  clickThroughTags,
  shouldTrackClickThrough,
  trackClickThrough,
}) => {
  const handleClickLink = (id) => {
    if (shouldTrackClickThrough) {
      trackClickThrough(id, clickThroughTags)
    }
  }

  const truncateBody = (body) => {
    // truncation is not a content strategy, but sometimes needs must
    const max = 240
    if (!body.length || body.length <= max) return body
    // split by sentence, without splitting in the middle of URLs
    return body.split('. ')[0]
  }

  if (!result) return null
  return (
    <li
      className="result"
    >
      <a
        href={result?.url?.raw}
        className="result-link"
        onClick={() => handleClickLink(result?.id?.raw)}
      >
        <div className="result-image">
          <Image image={getSearchImageObj(result)} sizes="225x127" />
        </div>
        <div className="result-content">
          <StyledText el="h2" className="display5" style={{ fontWeight: 600 }}>{result?.title?.raw}</StyledText>
          {
            (Array.isArray(result?.category?.raw) && result?.category?.raw?.length > 0) && (
              <ul className="category-list">
                {
                  result.category.raw.map(
                    category => (
                      <StyledText
                        className="cardLabel"
                        el="li"
                        style={{ fontWeight: 600 }}
                        key={category}
                      >
                        {category}
                      </StyledText>
                    )
                  )
                }
              </ul>
            )
          }
          {
            typeof result?.category?.raw === 'string' && (
              <ul className="category-list">
                <StyledText className="cardLabel" el="li" style={{ fontWeight: 600 }}>
                  {result.category.raw}
                </StyledText>
              </ul>
            )
          }
          {
            typeof result?.resultDescriptionTx?.raw === 'string' && (
              <StyledText className="lead2">{result.resultDescriptionTx.raw}</StyledText>
            )
          }
          {
            typeof result?.category?.raw === 'string'
            && result?.category?.raw === 'Help Article'
            && !result?.resultDescriptionTx?.raw && (
              <StyledText className="lead2">
                {truncateBody(result?.body?.raw)}
              </StyledText>
            )
          }
        </div>
      </a>
      <style jsx>{categoryListStyles}</style>
      <style jsx>{resultStyles}</style>
    </li>
  )
}

STVResultView.propTypes = {
  result: SEARCH_RESULT.isRequired,
  clickThroughTags: PropTypes.arrayOf(PropTypes.string),
  shouldTrackClickThrough: PropTypes.bool,
  trackClickThrough: PropTypes.func.isRequired,
}

STVResultView.defaultProps = {
  clickThroughTags: [],
  shouldTrackClickThrough: true,
}

export default withSearch(({ trackClickThrough }) => ({ trackClickThrough }))(STVResultView)
